import React from "react";
import StatCard from "./StatCard";

interface StatsGridProps {
  waterExpense: number;
  electricityExpense: number;
  pendingPayments: number;
  pendingReadings: number;
}

const StatsGrid = ({ waterExpense, electricityExpense, pendingPayments, pendingReadings }: StatsGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mt-4 flex-shrink-0">
      <StatCard
        title="Gastos de agua"
        value={`$${waterExpense.toLocaleString()}`}
        trend="up"
        bgColor="bg-primary/10"
        subtitle="Último mes"
      />
      <StatCard
        title="Electricidad"
        value={`$${electricityExpense.toLocaleString()}`}
        trend="down"
        bgColor="bg-accent/10"
        subtitle="Último mes"
      />
      <StatCard
        title="Pagos pendientes"
        value={pendingPayments.toString()}
        trend="up"
        bgColor="bg-secondary/10"
        subtitle="Último mes"
      />
      <StatCard
        title="Lecturas pendientes"
        value={pendingReadings.toString()}
        trend="down"
        bgColor="bg-muted"
        subtitle="Último mes"
      />
    </div>
  );
};

export default StatsGrid;